import { ShipFighter, DreadNought } from "./ships/index.js";
import { randomInt } from "./enemy.js";

const pickRandomEnemy = () => {
  const num = randomInt(0, 1);
  switch (num) {
    case 0:
      return new ShipFighter();
    case 1:
      return new DreadNought();
    default:
      break;
  }
};

export const EnemyGenerator = (enemyList) => {
  const randomEnemy = pickRandomEnemy();
  const defaultEnemy = new ShipFighter();

  let count = 0;
  for (const enemy of enemyList) {
    if (enemy.name == randomEnemy.name) count++;
    if (count >= enemy.rarity) return;
  }

  if (count <= randomEnemy.rarity) {
    enemyList.push(randomEnemy);
  } else {
    enemyList.push(defaultEnemy);
  }
};
